import React from 'react';
import { useIntl } from 'umi';
import { specialSecimalFormatPercentage } from '@op/utils/value';
import './index.scss';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';

export default function PopGameAffinity({
  data,
}: {
  data: Array<{
    affinity: number;
    cover: string;
    game_count: number;
    game_id: string;
    game_name: string;
  }>;
}) {
  const { formatMessage } = useIntl();
  if (!data || data.length === 0) return null;
  return (
    <div className="pop-game-affinity">
      <div className="pop-game-affinity-header">
        <div className="pop-game-affinity-th  pop-game-affinity-th-info">
          {formatMessage({ id: 'Games' })}
        </div>

        <div className="pop-game-affinity-th  pop-game-affinity-th-num">
          {formatMessage({ id: 'Game Affinity' })}
        </div>
      </div>
      <div className="pop-game-affinity-body">
        <div className="pop-game-affinity-list">
          {data.map((item: any) => {
            return (
              <div className="pop-game-affinity-item" key={item.game_id}>
                <div className="pop-game-affinity-td pop-game-affinity-td-info">
                  <RenderGameIcon
                    className="pop-game-affinity-td-img"
                    gameInfo={{
                      entity_type: 'mobile',
                      cover: item.cover,
                      edition_unified_id: item.game_id,
                    }}
                    key={item.game_id}
                  ></RenderGameIcon>
                  <div className="pop-game-affinity-td-title">
                    {item.game_name}
                  </div>
                </div>
                <div className="pop-game-affinity-td pop-game-affinity-td-num">
                  {specialSecimalFormatPercentage(item.affinity)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
